<template>
  <div v-if='listDestinationLinks && listDestinationLinks.items && listDestinationLinks.items.length ||
             listActivitiesLinks && listActivitiesLinks.items && listActivitiesLinks.items.length ||
             listDurationLinks && listDurationLinks.items && listDurationLinks.items.length'
       class="wp-100 pa-50 mb-pa-30 pb-40 mb-pb-20 bd-1 bd-blue-branding br-14 mt-80">
    <h2 class="fw-900 fs-36 mb-fs-28 mt-0 mb-30">
      Quick links
    </h2>
    <div class="nml-13 nmr-13">
      <div v-if='listDestinationLinks && listDestinationLinks.items && listDestinationLinks.items.length' class="pl-13 pr-13 mb-22">
        <p class="black fs-16 lh-16 mt-0 mb-10 fw-700">
          {{destinationTitle(listDestinationLinks.title)}}
        </p>
        <ul class="list pl-0 mb-0 flex flex-wrap">
          <li class="wp-25 mb-wp-100 minw-279 mb-10" v-for="(item,index) in listDestinationLinks.items" :key = index>
            <router-link :to='item.url' rel="noindex, nofollow" class="fs-14 lh-18" @click="toTop(item.url)">
              <span class="gray-dark mr-5 dib">{{item.title}}</span>
              <span class="gray-medium">({{item.number_of_trips}})</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if='listActivitiesLinks && listActivitiesLinks.items && listActivitiesLinks.items.length' class="pl-13 pr-13 mb-22">
        <p class="black fs-16 lh-16 mt-0 mb-10 fw-700">
          {{listActivitiesLinks.title}}
        </p>
        <ul class="list pl-0 mb-0 flex flex-wrap">
          <li class="wp-25 mb-wp-100 minw-279 mb-10" v-for="(item,index) in listActivitiesLinks.items" :key = index>
            <router-link :to='item.url' rel="noindex, nofollow" class="fs-14 lh-18" @click="toTop(item.url)">
              <span class="gray-dark mr-5 dib">{{item.title}}</span>
              <span class="gray-medium">({{item.number_of_trips}})</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if='listDurationLinks && listDurationLinks.items && listDurationLinks.items.length' class="pl-13 pr-13">
        <p class="black fs-16 lh-16 mt-0 mb-10 fw-700">
          {{listDurationLinks.title}}
        </p>
        <ul class="list pl-0 mb-0 flex flex-wrap">
          <li class="wp-25 mb-wp-100 minw-279 mb-10" v-for="(item,index) in listDurationLinks.items" :key = index>
            <router-link :to='item.url' rel="noindex, nofollow" class="fs-14 lh-18" @click="toTop(item.url)">
              <span class="gray-dark mr-5 dib">{{item.title}}</span>
              <span class="gray-medium">({{item.number_of_trips}})</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue'
import { useGalleryStore } from '~/store/pinia/gallery'

export default {
  name: 'QuickLink',
  props: ['list'],
  setup() {
    const galleryStore = useGalleryStore()
    const route = useRoute()
    const listDestinationLinks = computed(() => galleryStore.quickLinksData?.destinaions)
    const listActivitiesLinks = computed(() => galleryStore.quickLinksData?.activities)
    const listDurationLinks = computed(() => galleryStore.quickLinksData?.duration)
    const galleryInfor = computed(() => galleryStore.galleryInfor)

    const destinationTitle = (title) => {
      if(galleryInfor.value && galleryInfor.value.settings && galleryInfor.value.name) {
        if(galleryInfor.value.settings.page_type === 'country' ||
          galleryInfor.value.settings.page_type === 'activity' && galleryInfor.value.settings.page_level === 2) {
          return `${galleryInfor.value.name} ${title}`
        }
      }

      return title
    }

    const toTop = (url) =>{
      if(!url) return
      if(route.path.includes(url)) {
        document.getElementById('html').style.scrollBehavior = "smooth"
        var elmnt = document.getElementById("dj-app")
        elmnt.scrollIntoView()
      }
    }

    return {listDestinationLinks,listActivitiesLinks,listDurationLinks, destinationTitle, toTop}
  }
}
</script>
